<div
  style="position: relative"
  [ngClass]="{ 'p-disabled': loading }"
  class="tree-table-wrapper"
>
  <p-treetable
    #treeTable
    [value]="tableData && !loading ? tableData : placeholderData"
    [rowHover]="rowHover"
    [columns]="visibleColumns"
    selectionMode="multiple"
    columnResizeMode="expand"
    [resizableColumns]="resizableColumns"
    [reorderableColumns]="reorderableColumns"
    [lazyLoadOnInit]="false"
    [lazy]="true"
    [totalRecords]="+generalTotal"
    [rows]="limit()"
    [first]="offset"
    [scrollable]="true"
    [scrollHeight]="height + 'px'"
    [paginator]="paginator"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [frozenColumns]="frozenColumns"
    [frozenWidth]="frozenWidth + 'px'"
    (onColReorder)="onColReorder($event)"
    (onPage)="onPageChange($event)"
    [loading]="loading && tableData && !tableColumns.length"
  >
    <ng-template #colgroup let-columns>
      <colgroup>
        @for (col of columns; track col.field) {
        <col [ngStyle]="{ 'min-width.px': col.width || 200 }" />
        }
      </colgroup>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col.field; let i = $index) {
        @if(col.visible) {
        <th
          ttReorderableColumn
          ttResizableColumn
          [pTooltip]="col.headerTooltip"
          tooltipPosition="top"
        >
          <div class="table-head-container">
            <div class="table-head-left">
              <span>{{ col.name }}</span>
              @if(col.sorting && tableData && tableData.length) {
              @if(!col.sortOrder || col.sortOrder === 1 ) {
              <span
                class="sort-icon"
                (click)="changeSorting(col, i)"
                [class.sorted]="col.sortOrder"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.52794 2.86201C7.78829 2.60166 8.2104 2.60166 8.47075 2.86201L13.1374 7.52868C13.3978 7.78903 13.3978 8.21114 13.1374 8.47149C12.8771 8.73184 12.455 8.73184 12.1946 8.47149L8.66602 4.94289V12.6667C8.66602 13.0349 8.36754 13.3334 7.99935 13.3334C7.63116 13.3334 7.33268 13.0349 7.33268 12.6667V4.94289L3.80409 8.47149C3.54374 8.73184 3.12163 8.73184 2.86128 8.47149C2.60093 8.21114 2.60093 7.78903 2.86128 7.52868L7.52794 2.86201Z"
                    fill="#5D6983"
                  />
                </svg>
              </span>
              } @else if(col.sortOrder === -1) {
              <span
                class="sort-icon"
                (click)="changeSorting(col, i)"
                [class.sorted]="col.sortOrder"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99935 2.66675C8.36754 2.66675 8.66602 2.96522 8.66602 3.33341V11.0573L12.1946 7.52868C12.455 7.26833 12.8771 7.26833 13.1374 7.52868C13.3978 7.78903 13.3978 8.21114 13.1374 8.47149L8.47075 13.1382C8.2104 13.3985 7.78829 13.3985 7.52794 13.1382L2.86128 8.47149C2.60093 8.21114 2.60093 7.78903 2.86128 7.52868C3.12163 7.26833 3.54374 7.26833 3.80409 7.52868L7.33268 11.0573V3.33341C7.33268 2.96522 7.63116 2.66675 7.99935 2.66675Z"
                    fill="#5D6983"
                  />
                </svg>
              </span>
              } }
            </div>
            <div class="table-head-right" (click)="toggleFrozenColumn(col)">
              <svg
                [ngStyle]="{ visibility: col.isPinned ? 'visible' : 'hidden' }"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                class="pin-icon"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.83187 1.03508C9.12501 0.842802 9.4822 0.774012 9.82579 0.843664C10.0852 0.896247 10.2834 1.03601 10.4311 1.15913C10.5722 1.27679 10.7303 1.43485 10.9003 1.60497L14.3587 5.06328C14.5288 5.23337 14.6868 5.3914 14.8045 5.53256C14.9276 5.68026 15.0674 5.87845 15.12 6.13785C15.1896 6.48143 15.1208 6.83862 14.9285 7.13177C14.7834 7.35309 14.58 7.4852 14.4109 7.57661C14.2492 7.66398 14.0437 7.75201 13.8226 7.84675L12.1392 8.56819C12.1014 8.58439 12.083 8.59232 12.0697 8.59838C12.0694 8.59853 12.0691 8.59866 12.0688 8.5988C12.0686 8.59902 12.0683 8.59925 12.0681 8.59948C12.0575 8.60958 12.0433 8.62374 12.0142 8.65281L10.976 9.69106C10.9306 9.73648 10.9083 9.75892 10.8925 9.77577C10.8921 9.77619 10.8918 9.77658 10.8914 9.77697C10.8913 9.77748 10.8912 9.77801 10.891 9.77856C10.8857 9.80098 10.8794 9.832 10.8668 9.89499L10.3737 12.3607C10.3152 12.6531 10.2627 12.9161 10.2013 13.1226C10.14 13.3292 10.039 13.596 9.81156 13.7979C9.52061 14.056 9.13123 14.1739 8.74593 14.1205C8.44471 14.0788 8.21269 13.9127 8.04703 13.7748C7.88149 13.6371 7.69187 13.4474 7.48099 13.2365L5.57438 11.3299L2.28199 14.6223C2.02222 14.8821 1.60107 14.8821 1.34131 14.6223C1.08154 14.3626 1.08154 13.9414 1.34131 13.6816L4.6337 10.3892L2.72713 8.48266C2.51622 8.27178 2.32657 8.08215 2.18881 7.91661C2.05096 7.75095 1.88489 7.51893 1.84313 7.2177C1.78971 6.83241 1.90761 6.44303 2.16577 6.15207C2.36761 5.92461 2.63449 5.82367 2.84108 5.7623C3.04753 5.70097 3.31052 5.64839 3.60299 5.58992L6.06865 5.09678C6.13165 5.08418 6.16266 5.07789 6.18508 5.07259C6.18563 5.07246 6.18616 5.07233 6.18667 5.07221C6.18706 5.07185 6.18746 5.07148 6.18787 5.07109C6.20472 5.05538 6.22716 5.03307 6.27259 4.98764L7.31083 3.9494C7.3399 3.92032 7.35406 3.90611 7.36416 3.89554C7.3644 3.89529 7.36462 3.89506 7.36484 3.89482C7.36498 3.89453 7.36511 3.89423 7.36526 3.89392C7.37132 3.88062 7.37926 3.8622 7.39545 3.8244L8.11689 2.14103C8.21164 1.91991 8.29966 1.71446 8.38703 1.55277C8.47844 1.38361 8.61055 1.18024 8.83187 1.03508ZM8.40132 12.2755C8.63905 12.5132 8.78513 12.6584 8.89796 12.7523C8.90523 12.7583 8.91203 12.7638 8.91836 12.7689C8.92082 12.7612 8.9234 12.7528 8.92609 12.7437C8.96789 12.603 9.00893 12.4012 9.07487 12.0716L9.56236 9.63409C9.56394 9.62617 9.56555 9.61803 9.56721 9.60969C9.58534 9.51806 9.60818 9.40265 9.65208 9.29073C9.69021 9.19352 9.73965 9.10114 9.79939 9.01549C9.86816 8.91689 9.95151 8.83386 10.0177 8.76795C10.0237 8.76195 10.0296 8.75609 10.0353 8.75037L11.0736 7.71213C11.0772 7.70849 11.0809 7.70474 11.0848 7.70091C11.1271 7.65849 11.1804 7.60506 11.2412 7.55676C11.294 7.51476 11.35 7.47685 11.4087 7.44335C11.4761 7.40483 11.5455 7.37518 11.6006 7.35166C11.6056 7.34953 11.6105 7.34745 11.6152 7.34543L13.2743 6.63436C13.5281 6.52562 13.6765 6.4613 13.7784 6.40622C13.7839 6.40327 13.789 6.40047 13.7937 6.39782C13.7903 6.39361 13.7866 6.38913 13.7826 6.38437C13.7085 6.29537 13.5945 6.18051 13.3993 5.98532L9.97831 2.5643C9.78312 2.36911 9.66827 2.25517 9.57927 2.18098C9.57451 2.17701 9.57002 2.17334 9.56581 2.16994C9.56317 2.17466 9.56037 2.17974 9.55742 2.18519C9.50234 2.28712 9.43801 2.43557 9.32928 2.68929L8.61821 4.34845C8.61618 4.35318 8.6141 4.35805 8.61198 4.36303C8.58845 4.41813 8.55881 4.48753 8.52029 4.55496C8.48679 4.61359 8.44888 4.66959 8.40688 4.72246C8.35858 4.78327 8.30515 4.83657 8.26273 4.87888C8.2589 4.8827 8.25515 4.88644 8.25151 4.89008L7.21327 5.92832C7.20755 5.93404 7.20169 5.93992 7.19569 5.94594C7.12978 6.01212 7.04676 6.09548 6.94815 6.16425C6.8625 6.22398 6.77012 6.27342 6.67291 6.31155C6.56099 6.35545 6.44558 6.37829 6.35396 6.39643C6.34562 6.39808 6.33748 6.39969 6.32955 6.40128L3.89209 6.88877C3.56241 6.95471 3.36062 6.99575 3.21992 7.03754C3.21085 7.04024 3.20247 7.04282 3.19475 7.04528C3.19981 7.05161 3.20535 7.05841 3.2114 7.06568C3.30529 7.17851 3.45042 7.32459 3.68815 7.56232L8.40132 12.2755Z"
                  fill="#5D6983"
                />
              </svg>
            </div>
          </div>
        </th>
        } }
      </tr>
    </ng-template>
    <ng-template #body let-rowNode let-rowData="rowData" let-columns="columns">
      <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
        @for (col of columns; track col.field; let index = $index) {
        <td [ngClass]="col.cellClass">
          @if(loading || !tableData || !tableData.length) {
          <p-skeleton />
          } @else {
          <span>{{ rowData[col.field] }}</span>
          }
        </td>
        }
      </tr>
    </ng-template>
    <ng-template #paginatorleft>
      <div class="general-summary">
        @if(loading) {
        <span>Loading total...</span>
        } @else { @if(generalTotal && tableData && tableData.length) {
        <span>{{
          'Total: ' + generalTotal + ' (visible: ' + tableData.length + ')'
        }}</span>
        } }
      </div>
    </ng-template>
  </p-treetable>
  @if(tableData && !tableData.length && !loading) {
  <div class="empty-message-text">
    <span> No Data Available</span>
  </div>
  }
  <p-popover #op>
    <div class="manage-columns">
      <ul class="columns-list">
        @for (column of tableColumns; track column.field; let index = $index) {
        <li>
          <p-checkbox [binary]="true" [(ngModel)]="column.visible" />
          <span>{{ column.name }}</span>
        </li>
        }
      </ul>
    </div>
  </p-popover>
</div>
